import service from "../../services/gestionEmpleados/employee";
import employee from "../../models/gestionEmpleados/empleados/employees";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    service: new service(),
    employees: [],
    totalEmployees: 0,
    limit: 44, // Elementos por página
    offset: 0, // Posición inicial
    currentPage: 1,
    where: {},
    selectedFilter: null, // Filtro seleccionado (clave)
    filterValue: "", // Filtro valor (valor)
    itemsEmployed: [],
    search: "",
    editEmployed: [],
    newEmployed: [],
    dateFrom: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    dateTo: null,
    photo: {},
    showCard: false,
    showTable: false,
    dateDown: null,
    dateHigh: null,
    addHigh: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    addDown: null,
    orderEmployees: [],
    checkTo: true,
    showAdd: false,
    isEnabled: false,
    montlyTab: [],
    devices: [],
    fingerScan: {},
    usersSuprema: [],
    newUserSuprema: {},
    userFingerprintTemplates: [],
    scanFingerPrint: null,
    onlyActive: false,
  },

  mutations: {
    setOnlyActive(state, data) {
      state.onlyActive = data;
    },
    setIsEnabled(state, data) {
      state.isEnabled = data;
    },
    setMontlyTab(state, data) {
      state.montlyTab = data;
    },
    setEmployees(state, data) {
      if (Array.isArray(data)) {
        state.employees = data;
        state.totalEmployees = data.length;
      } else {
        state.employees = data.items || [];
        state.totalEmployees = data.total || data.items?.length || 0;
      }
    },
    setFilterValue(state, data) {
      state.filterValue = data;
    },
    setSelectedFilter(state, data) {
      state.selectedFilter = data;
    },
    setOffset(state, data) {
      state.offset = data;
    },
    setLimit(state, data) {
      state.limit = data;
    },
    setCurrentPage(state, data) {
      state.currentPage = data;
    },
    setWhere(state, data) {
      state.where = data;
    },
    setItemsEmployed(state, data) {
      state.itemsEmployed = data;
    },
    setSearch(state, data) {
      state.search = data;
    },
    setEditEmployed(state, data) {
      state.editEmployed = data;
    },
    setNewEmployed(state, data) {
      state.newEmployed = data;
    },
    setDateFrom(state, data) {
      state.dateFrom = data;
    },
    setDateTo(state, data) {
      state.dateTo = data;
    },
    setPhoto(state, data) {
      state.photo = data;
    },
    setShowCard(state, data) {
      state.showCard = data;
    },
    setShowTable(state, data) {
      state.showTable = data;
    },
    setDateDown(state, data) {
      state.dateDown = data;
    },
    setDateHigh(state, data) {
      state.dateHigh = data;
    },
    setAddHigh(state, data) {
      state.addHigh = data;
    },
    setAddDown(state, data) {
      state.addDown = data;
    },
    setOrderEmployees(state, data) {
      state.orderEmployees = data;
    },
    setCheckTo(state, data) {
      state.checkTo = data;
    },
    setShowAdd(state, data) {
      state.showAdd = data;
    },
    setDevices(state, data) {
      state.devices = data;
    },
    setFingerScan(state, data) {
      state.fingerScan = data;
    },
    setUsersSuprema(state, data) {
      state.usersSuprema = data;
    },
    setNewUserSuprema(state, data) {
      state.newUserSuprema = data;
    },
    setUserFingerprintTemplates(state, data) {
      state.userFingerprintTemplates = data;
    },
    setScanFingerPrint(state, data) {
      state.scanFingerPrint = data;
    },
  },
  actions: {
    async getEmployees(
      { state, dispatch, commit },
      { photo, limit, offset, where, order, soloActivos } = {}
    ) {
      dispatch("loader/startLoading", null, { root: true });

      try {
        const item = await state.service.getEmployees(photo, {
          limit,
          offset,
          where,
          order,
          soloActivos,
        });

        commit("setEmployees", item);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    async getMontlyTab({ state, dispatch, commit }, data) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getMontlyTab(data);

          commit("setMontlyTab", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async getEmployeesPaginate({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          const hasFilters = Object.keys(state.where).length > 0;
          const options = {
            limit: hasFilters ? undefined : state.limit,
            offset: hasFilters ? undefined : state.offset,
            where: state.where,
            soloActivos: state.onlyActive,
          };
          const items = await state.service.getEmployees(null, options);
          commit("setEmployees", items);
          resolve(true);
        } catch (error) {
          console.error("Error en getEmployeesPaginate:", error);
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    updatePage({ state, dispatch, commit }, page) {
      return new Promise((resolve) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          const newOffset =
            state.where && Object.keys(state.where).length > 0
              ? 0
              : (page - 1) * state.limit;

          commit("setOffset", newOffset);
          commit("setCurrentPage", page);

          dispatch("getEmployeesPaginate").then(() => {
            resolve(true);
          });
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    updateWhere({ dispatch, commit }, where) {
      return new Promise((resolve) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          Promise.all([
            commit("setWhere", where),
            commit("setOffset", 0),
            commit("setCurrentPage", 1),
          ]).then(() => {
            dispatch("getEmployeesPaginate").then(() => {
              resolve(true);
            });
          });
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async edit({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.edit(state.editEmployed).then(() => {
            let item = state.editEmployed;

            commit("setEditEmployed", item);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async newEmployed({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });

          const { data } = await state.service.addEmployed(state.newEmployed);

          let newItem = employee.fromJson({
            empId: data.empId,
            apellido: data.apellido,
            nombre: data.nombre,
            legajo: data.legajo,
            tdoc: data.tdoc,
            ndoc: data.ndoc,
            fecAlta: data.fecAlta,
            fecBaja: data.fecBaja ?? null,
            vistaPrevia: data.vistaPrevia,
            etiquetas: [],
          });

          let options = state.employees;
          options.push(newItem);

          // actualizar estado
          commit("setEmployees", options);

          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async getPhoto({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = await state.service.getPhoto();

          commit("setPhoto", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async enabledEmployed({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = state.editEmployed;
          await state.service.enabledEmployed(item.empId).then(() => {
            item.isEnabled = state.isEnabled;
            const updatedEmployees = state.employees.map((option) => {
              if (option.empId === item.empId) {
                option.downDate = null;
                option.formatDownDate = null;
                option.baNoEx = true;
              }
              return option;
            });
            commit("setEmployees", updatedEmployees);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    async disabledEmployed({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          let item = state.editEmployed;
          await state.service.disabledEmployed(item.empId).then(() => {
            item.isEnabled = state.isEnabled;
            const updatedEmployees = state.employees.map((option) => {
              if (option.empId === item.empId) {
                option.downDate = moment().format("DD-MM-YYYY");
                option.formatDownDate = moment().format("DD-MM-YYYY");
              }
              return option;
            });
            commit("setEmployees", updatedEmployees);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    getDevices({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          const item = await state.service.getDevices();
          commit("setDevices", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    getUsersSuprema({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          const item = await state.service.getUsersSuprema();
          commit("setUsersSuprema", item);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    /* 
  ------[SE COMENTA PORQUE SE ASUME QUE SI USUARIO NO EXISTE EN SUPREMA NO SE VA A CREAR EN DS9]------
    addUserSuprema({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.newUser(state.newUserSuprema);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
 */
    startScan({ state, dispatch, commit }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          const item = await state.service.scanFingerPrint(state.fingerScan);
          commit("setScanFingerPrint", item);

          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
    identifyScan({ state, dispatch }, template0) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        return state.service.identifyFingerPrint(template0);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },
    verifyScan({ state, dispatch }, { template0, template1 }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        return state.service.verifyFingerprint(template0, template1);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },

    getInfoUser({ state, dispatch, commit }, empId) {
      return new Promise(async (resolve) => {
        try {
          dispatch("loader/startLoading", null, { root: true });

          let item = await state.service.getInfoUser(empId);

          if (
            item.fingerprint_templates === null ||
            item.fingerprint_templates === undefined
          ) {
            item = [];
          } else {
            item = item.fingerprint_templates;
          }

          commit("setUserFingerprintTemplates", item);

          resolve(true);
        } catch (error) {
          console.error("Error getInfoUser:", error.response?.status);
          resolve(false);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    editFingerprintToUser({ state, dispatch }, { id, arrayModified }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.editFingerprintToUser(id, arrayModified);
          resolve(true);
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
  },
  getters: {
    totalPages(state) {
      return Math.ceil(state.totalEmployees / state.limit);
    },
    currentPlaceholder: (state) => {
      if (!state.selectedFilter) return "Selecciona un filtro";
      switch (state.selectedFilter) {
        case "nombre":
          return "Buscar por nombre";
        case "apellido":
          return "Buscar por apellido";
        case "nombre+apellido":
          return "Buscar por nombre y apellido";
        case "email":
          return "Buscar por correo";
        case "ndoc":
          return "Buscar por número de documento";
        case "legajo":
          return "Buscar por legajo";
        case "activos":
          return "Activos";
        default:
          return "Buscar";
      }
    },
  },
};
